export const isNonEmpty = <T>(arr: ReadonlyArray<T> | null | undefined) =>
  arr != null && arr.length > 0;
